import request from '@/config/axios'

// 获取系统设置
export const GetSystemSetting = (params) => {
  return request.get({
    url: 'system/general/setting',
    params,
    baseUrl:'m2i'
  })
}

export const SetSystemSetting = (data) => {
   return request.post({
     url: 'system/general/setting',
     data,
    baseUrl:'m2i'
   })
}

export const GetLang = (params) => {
  return request.get({
    url: 'i18n-data',
    baseUrl:'m2i',
    params
  })
}

export const RegisterLang = (data) => {
  return request.post({
    url: '/i18n-data',
    baseUrl:'m2i',
    data:data
  })
}

export const VideoOnline = (url,username,password) => {
  return request.put({
    url: `/AdvStreamingService/Authority/Online`,
    baseUrl: url,
    withCredentials: false,
    data: {
      request: {
        username: username,
        password: password
      }
    }
  })
}

export const VideoLiveStream = (url,channel,sessionID,streamingProtocol,IVSID,streamType,withAudio) => {
  return request.put({
    url: `/AdvStreamingService/LiveStream`,
    baseUrl: url,
    withCredentials: false,
    data: {
      request: {
        channel: channel,
        method: "connection",
        sessionID: sessionID,
        streamingProtocol: streamingProtocol,
        IVSID: IVSID,
        streamType: streamType,
        withAudio: withAudio,
        pathType: "relative"
      }
    }
  })
}

export const VideoPlaybackStream = (url,channel,sessionID,streamingProtocol,IVSID,streamType,withAudio,beginTime,endTime) => {
  return request.put({
    url: `/AdvStreamingService/PlaybackStream`,
    baseUrl: url,
    withCredentials: false,
    data: {
      request: {
        channel: channel,
        method: "connection",
        sessionID: sessionID,
        streamingProtocol: streamingProtocol,
        IVSID: IVSID,
        streamType: streamType,
        withAudio: withAudio,
        pathType: "relative",
        beginTime: beginTime,
        endTime: endTime
      }
    }
  })
}

export const getYsAccessToken = (data) => {
  return request.post({
    url: '/video/ezviz/token',
    baseUrl:'m2i',
    data:data
  })
}

export const getYsCameralist = (params) => {
  return request.get({
    url: '/video/ezviz/cameralist',
    baseUrl:'m2i',
    params:params
  })
}

export const getYsAddress = (data) => {
  return request.post({
    url: '/video/ezviz/live/address',
    baseUrl:'m2i',
    data:data
  })
}